import { render, staticRenderFns } from "./ResultTopicWomenHealth.vue?vue&type=template&id=963a0b24&scoped=true"
import script from "./ResultTopicWomenHealth.vue?vue&type=script&lang=js"
export * from "./ResultTopicWomenHealth.vue?vue&type=script&lang=js"
import style0 from "./ResultTopicWomenHealth.vue?vue&type=style&index=0&id=963a0b24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963a0b24",
  null
  
)

export default component.exports